import { Button } from "@mui/material";
import { useSnackbar } from 'notistack';

export default function ReloadButton({setReloadToken, loading}) {

    const { enqueueSnackbar } = useSnackbar();
    return (
        <Button
            size="small"
            variant="outlined"
            onClick={() => {
                setReloadToken((x) => x + 1)
                enqueueSnackbar('Заказы обновлены', { variant: 'success' });
            }}
            disabled={loading}
        >
            ОБНОВИТЬ
        </Button>
    );
}
